import { render, staticRenderFns } from "./LLMetaIconInfo.vue?vue&type=template&id=6b230796&scoped=true"
import script from "./LLMetaIconInfo.vue?vue&type=script&lang=js"
export * from "./LLMetaIconInfo.vue?vue&type=script&lang=js"
import style0 from "./LLMetaIconInfo.vue?vue&type=style&index=0&id=6b230796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b230796",
  null
  
)

export default component.exports